import HTML5Backend from 'react-dnd-html5-backend';
import {DragDropContext} from 'react-dnd';

import _ from 'lodash';

const shouldIgnoreEvent = (e) => {
    let res = false;

    try {
        res = !!gd.utils.Dom.findNodeByClassName(e.target, 'DraftEditor-editorContainer') ||
            (e.path && !!_.find(e.path, p=>p.className && p.className.includes('DraftEditor-editorContainer')));
    } catch(err) {
        gd.utils.captureErrorMessage('ModifiedBackend shouldIgnoreEvent: error', {
            level: 'error', // one of 'info', 'warning', or 'error'
            extra: {
                error: err,
                path: e.path
            }
        });
    }

    return res;
}

const ModifiedBackend = (...args) => {
    const instance = new HTML5Backend(...args);

    const listeners = [
        'handleTopDragStart',
        'handleTopDragStartCapture',
        'handleTopDragEndCapture',
        'handleTopDragEnter',
        'handleTopDragEnterCapture',
        'handleTopDragLeaveCapture',
        'handleTopDragOver',
        'handleTopDragOverCapture',
        'handleTopDrop',
        'handleTopDropCapture'
    ];

    //ignore only components with specified class name, replacing preventDefault causes dropzone (module) malfunction
    listeners.forEach(name => {
        const original = instance[name];
        instance[name] = (e, ...extraArgs) => {
            // e.preventDefault = () => {};

            if (!shouldIgnoreEvent(e)) original(e, ...extraArgs);
            else e.preventDefault = () => {};
        };
    });

    return instance;
};


const _DNDContext = new DragDropContext(ModifiedBackend);

module.exports = _DNDContext;